import { Braces } from "lucide-react";
import { Link } from "react-router-dom";

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="brand" aria-label="ForgeCode Academy home">
      <span className="brand-mark"><Braces size={21} strokeWidth={2.4} /></span>
      {!compact && <span>Forge<span>Code</span></span>}
    </Link>
  );
}
